import { Modal, ModalOverlay, ModalContent, Flex, ModalBody, Text } from '@chakra-ui/react'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IconWithinCircle } from '../../pages/Common/IconWithinCircle'
import { Button, Column } from '@ubirider/pick-component-library'

import warningIcon from '../../assets/alert_white.svg'

export function ErrorModal({ title, description, loading, onConfirm, isOpen, onOpen, onClose }) {
  const { t } = useTranslation()

  const initialRef = useRef(null)
  const finalRef = useRef(null)

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      size={{ sm: 'xs', md: 'md', lg: 'xl', xl: 'xl' }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Flex
            direction='column'
            align='center'
            justifyContent='center'
            p={{ sm: '24px 0px', md: '24px 0px', lg: '32px 56px', xl: '32px 56px' }}
            gap='32px'
          >
            <IconWithinCircle color='danger.600' icon={warningIcon} />
            <Column css={{ gap: 8 }}>
              <Text fontWeight='700' fontSize='24px' color='neutral.800' align='center'>
                {t(title ?? 'travel_history.settle_request_not_registered_title')}
              </Text>
              <Text fontWeight='600' fontSize='16px' color='neutral.600' align='center'>
                {t(description ?? 'travel_history.settle_request_not_registered_description')}
              </Text>
            </Column>

            <Flex gap='16px' display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }}>
              <Button
                onClick={onClose}
                style='outline'
                type='neutralLight'
                label={t('common.cancel')}
                css={{ width: '152px' }}
              />
              <Button
                onClick={onConfirm}
                loading={loading}
                style='solid'
                type='neutralDark'
                label={t('common.try_again')}
                css={{ width: '182px' }}
              />
            </Flex>
            <Flex
              gap='16px'
              alignSelf='stretch'
              direction='column'
              display={{ sm: 'flex', md: 'none', lg: 'none', xl: 'none' }}
            >
              <Button
                onClick={onConfirm}
                loading={loading}
                style='solid'
                type='neutralDark'
                label={t('common.try_again')}
                css={{ width: '100%' }}
              />
              <Button
                onClick={onClose}
                style='outline'
                type='neutralLight'
                label={t('common.cancel')}
                css={{ width: '100%' }}
              />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
